import { createFileRoute, Link, type FileRouteTypes } from "@tanstack/react-router";
import { useAnalyticsSummary } from "@/hooks/use-admin-analytics";
import { StatCardSkeleton } from "@/components/stat-card";
import { SummaryCards } from "./summary-cards";
import { TopTables } from "./top-tables";

export const Route = createFileRoute("/_admin/analytics/")({
  component: AnalyticsDashboardPage,
});

function AnalyticsDashboardPage() {
  const { data, isLoading, error } = useAnalyticsSummary();

  // Cast needed because the events route file is created elsewhere
  const eventsRoute = "/analytics/events" as FileRouteTypes["to"];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-slate-900">Analytics</h1>
        <Link to={eventsRoute} className="text-sm font-medium text-primary hover:text-primary/80">
          View All Events
        </Link>
      </div>

      {error && (
        <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-600">
          {error.message}
        </div>
      )}

      {isLoading && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <StatCardSkeleton />
          <StatCardSkeleton />
          <StatCardSkeleton />
          <StatCardSkeleton />
        </div>
      )}

      {data && (
        <>
          <SummaryCards data={data} />
          <TopTables data={data} />
        </>
      )}

      {!isLoading && !error && !data && (
        <p className="text-sm text-slate-400">No analytics data yet</p>
      )}
    </div>
  );
}
